// extracted by mini-css-extract-plugin
module.exports = {"container":"ModelDetails_container__4zMMK","videoWrapper":"ModelDetails_videoWrapper__2Juri","video":"ModelDetails_video__2vu_u"};